<template lang="html">
  <div>
    <div class="position-relative" style="margin: 0 -12px;">
      <div v-for="idx in (isFirst ? 6 : 2)" :key="idx" class="custom-skeleton-list">
        <div class="custom-skeleton-list-image">
          <v-skeleton-loader v-bind="attrs" type="image" />
        </div>
        <div class="custom-skeleton-list-content">
          <div class="custom-skeleton-list-text mb-2">
            <div class="custom-skeleton-list-avatar">
              <v-skeleton-loader v-bind="attrs" type="list-item-avatar" />
              <v-skeleton-loader v-bind="attrs" type="list-item-avatar" />
            </div>
          </div>
          <div class="custom-skeleton-list-text">
            <v-skeleton-loader v-bind="attrs" type="list-item-three-line" class="custom-three-line" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomSkeletonList',
  props: {
    isFirst: {
      default: true,
      type: Boolean
    }
  }
}
</script>
